import { render, staticRenderFns } from "./ProductionFiles.vue?vue&type=template&id=19abab3d&"
import script from "./ProductionFiles.vue?vue&type=script&lang=js&"
export * from "./ProductionFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports